import { createFileRoute } from "@tanstack/react-router";
import { ArbejdspladsPage, arbejdspladsHead } from "@/pages/ArbejdspladsPage";

export const Route = createFileRoute("/de/mi-unterstutzung-als-arbeitsplatz")({
  head: () => arbejdspladsHead("de"),
  component: () => <ArbejdspladsPage locale="de" />,
});
